<template>
  <span class="d-inline-flex align-center ga-2">
    <!-- O nome da dimensão antes do valor, quando ele não está dito em volta: o rótulo de um bloco,
         a restrição da janela de vincular. No "mover ou acrescentar" ele vem uma vez só, para as
         duas pontas. -->
    <span v-if="named" class="text-caption text-medium-emphasis">{{ value.dimension.name }}</span>
    <!-- Relacionamento pelo PropertyValue: lá o chip já sai com href de verdade e emitindo o clique,
         que é o que abre a ficha do item — o mesmo chip do card e da listagem. -->
    <ontos-property-value v-if="value.related" variant="cell" :property="value.dimension.property"
                          :value="value.related" :context="context" @link="$emit('link', $event)"/>
    <!-- Situação, seleção e o grupo "Não definido" não levam a lugar nenhum: é só o valor na FORMA
         dele — bolinha para situação, chip para opção de domínio —, e o grupo vazio simplesmente não
         tem cor. -->
    <ontos-colored-value v-else-if="value.option" :option="value.option" :form="formOf(value.dimension)"/>
  </span>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import PropertyValue from '@/components/live/instance/PropertyValue.vue'
import ColoredValue from '@/components/shared/ColoredValue.vue'
import {CoordinateValue, formOf} from '@/utils/kanbanDimensions'
import {InstanceContext} from '@/types/InstanceContext'

/**
 * Um valor de raia, como o app o desenha em toda parte fora da própria raia: o rótulo de um bloco,
 * as pontas do "mover ou acrescentar" e a restrição da janela de vincular, aberta pelo "+" de uma
 * raia. Eram três cópias do mesmo par `PropertyValue` / `ColoredValue`.
 */
@Component({
  emits: ['link'],
  name: 'ontos-lane-value',
  components: {'ontos-property-value': PropertyValue, 'ontos-colored-value': ColoredValue}
})
class LaneValue extends Vue {
  @Prop({type: Object, required: true}) readonly value!: CoordinateValue
  /** A coleção do quadro — é para onde aponta o link do item, quando o valor é um. */
  @Prop({type: Object, required: true}) readonly context!: InstanceContext
  /** Escreve o nome da dimensão antes do valor — "Gênero (● Samba)". */
  @Prop({type: Boolean, default: false}) readonly named!: boolean
  //exposta ao template: função de módulo não é enxergada de lá
  formOf = formOf
}

export default toNative(LaneValue)
</script>
